const defaults = {
    baseURL: '',
};
export function setRequesterDefaultConfig(config) {
    for (const [key, val] of Object.entries(config)) {
        // @ts-expect-error we can't type-check entries but it's fine
        defaults[key] = val;
    }
}
export function getRequesterRequestConfig() {
    return {
        baseURL: defaults.baseURL,
    };
}
